import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=37d672c5&scoped=true&"
var script = {}
import style0 from "./clock.vue?vue&type=style&index=0&id=37d672c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d672c5",
  null
  
)

export default component.exports